import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetAssessmentStudentsList = async function(
    locationId,
    parameters
) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/assessment-application/list/${locationId}${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const DeleteAssessmentStudents = async function(
    locationId,
    assessmentId
) {
    try {
        if (assessmentId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: assessmentId')
            )
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/location/${locationId}/assessment-application/${assessmentId}`,
            data: assessmentId,
        })
    } catch (e) {
        console.error(e)
    }
}

export const ChangeAssessmentStudentsStatus = async function(parameters) {
    try {
        const { publicId } = parameters
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/assessment/${publicId}/change-current`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetAssessmentReport = async function(assessmentPublicId) {
    try {
        if (assessmentPublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: assessmentPublicId')
            )
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/assessment-application/report/${assessmentPublicId}`,
        })
    } catch (e) {
        console.error(e)
    }
}

export const ChangeAssessmentStatus = async function(assessmentPublicIds) {
    try {
        const { publicIds } = assessmentPublicIds
        if (assessmentPublicIds === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: assessmentPublicId')
            )
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/assessment-application/${publicIds[0]}/change-publish`,
            data: assessmentPublicIds,
        })
    } catch (e) {
        console.error(e)
    }
}

export const ApplyAssessment = async function(students) {
    try {
        if (students === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: students')
            )
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/assessment-application`,
            data: students,
        })
    } catch (e) {
        console.error(e)
    }
}

export const SaveAnswers = async function(answers) {
    try {
        if (answers === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: answers')
            )
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/save-answers`,
            data: answers,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetAnswers = async function(answers) {
    try {
        if (answers === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: answers')
            )
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/get-answers`,
            data: answers,
        })
    } catch (e) {
        console.error(e)
    }
}

export const SaveComments = async function(comments) {
    try {
        if (comments === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: comments')
            )
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/assessment-application/comments`,
            data: comments,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetComments = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/assessment-application-comments-student`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const FinishAssessment = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/assessment-application/completed`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}
